export default __webpack_public_path__ + "static/media/B_major.65563023.jpg";